import React from 'react';

import Dialog from 'sharedreact/components/Dialog';
import RadioButton from 'sharedreact/components/RadioButton';
import { translate } from 'sharedreact/utils/LanguageSupport';

type Props = {
  language: string,
  show: boolean,
  allowRemoveData: boolean,

  onClose: () => void,
  onOptOut: (keepData: boolean) => void,
};

type State = {
  keepData: boolean
};

class UsageOptOutDialog extends React.Component<Props, State> {
  constructor (props: Props) {
    super(props);

    this.state = {
      keepData: true
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeValue = this.handleChangeValue.bind(this);
    this.keepData = this.keepData.bind(this);
    this.deleteData = this.deleteData.bind(this);
  }

  handleSubmit (event?: React.MouseEvent<HTMLButtonElement>): void {
    const { onOptOut } = this.props;

    event?.preventDefault();

    onOptOut(this.state.keepData);
  }

  handleChangeValue (name: string, value: any): void {
    switch (name) {
      case 'keepData': {
        this.setState({keepData: value});
        break;
      }
    }
  }

  keepData (): void {
    this.setState({keepData: true});
  }

  deleteData (): void {
    this.setState({keepData: false});
  }

  override render (): React.ReactNode {
    const { show, allowRemoveData, language, onClose } = this.props;

    return (
      <Dialog
        id='ae_dialog_usage_optout'
        show={show}
        language={language}
        title={translate('launcher.usage.dialog.optout')}
        onClose={onClose}
        onConfirm={this.handleSubmit}
        primaryButton='close'
      >
        <span>{translate('launcher.usage.optout.message.confirm')}</span><br />
        <span>{allowRemoveData ? translate('launcher.usage.optout.message.infolong') : translate('launcher.usage.optout.message.infoshort')}</span>
        {allowRemoveData
          ? <div>
            <RadioButton id='ae_usage_optout_radiobutton_keep' label={translate('launcher.usage.optout.option.keep')} checked={this.state.keepData} onChange={this.keepData} />
            <RadioButton id='ae_usage_optout_radiobutton_delete' label={translate('launcher.usage.optout.option.delete')} checked={!this.state.keepData} onChange={this.deleteData} />
          </div>
          : null
        }
      </Dialog>
    );
  }
}

export default UsageOptOutDialog;
